const hintParameterNamesMap = {
  model: 'ch_m',
  brands: 'ch_b',
  platform: 'ch_p',
  platformVersion: 'ch_pv',
  fullVersionList: 'ch_fvl',
};

/**
 * Converts a hint to a string and encodes it
 * @param {string | object} hint
 * @returns {string}
 */
const convertHintValue = (hint) => {
  if (!hint) {
    return '';
  }

  const hintValue = typeof hint === 'object' ? JSON.stringify(hint) : hint;

  return window.encodeURIComponent(hintValue);
};

/**
 *  Converts a hints object into a flat URL query string.
 * @param {Object} hints
 * @param {string} hints.model
 * @param {string} hints.platform
 * @param {string} hints.platformVersion
 * @param {{ brand: string; version: string }[]} hints.brands
 * @param {{ brand: string; version: string }[]} hints.fullVersionList
 * @returns {string}
 */
export const convertHintsToFlatUrlStructure = (hints) => {
  if (typeof hints !== 'object') {
    return '';
  }

  let result = '';

  for (const hintKey in hints) {
    const hintParameterName = hintParameterNamesMap[hintKey];
    const hintParameterValue = hints[hintKey];

    if (hintParameterName && hintParameterValue) {
      result += `&${hintParameterName}=${convertHintValue(hintParameterValue)}`;
    }
  }

  return result;
};
